var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgParkingLot02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2.5C3.79086 2.5 2 4.29086 2 6.5V18.5C2 20.7091 3.79086 22.5 6 22.5H18C20.2091 22.5 22 20.7091 22 18.5V6.5C22 4.29086 20.2091 2.5 18 2.5H6ZM11.7358 6.66016C10.4985 6.66016 9.32515 6.74016 8.21582 6.90016V18.5002H10.8878V14.5962C11.3572 14.6388 11.7838 14.6602 12.1678 14.6602C13.7038 14.6602 14.8665 14.3082 15.6558 13.6042C16.4558 12.8895 16.8558 11.8442 16.8558 10.4682C16.8558 7.92949 15.1492 6.66016 11.7358 6.66016ZM11.8958 12.6602C11.5652 12.6602 11.2292 12.6335 10.8878 12.5802V8.82016C11.2078 8.75616 11.5438 8.72416 11.8958 8.72416C13.5065 8.72416 14.3118 9.35882 14.3118 10.6282C14.3118 11.2682 14.0985 11.7695 13.6718 12.1322C13.2558 12.4842 12.6638 12.6602 11.8958 12.6602Z",
    fill: "#626264"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgParkingLot02);
export default __webpack_public_path__ + "static/media/bg_parking-lot02.a440c13cc374646907f4017efc952166.svg";
export { ForwardRef as ReactComponent };